import {
  User,
  UserCredential,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth"
import { getFirebaseAuth } from "./firebase"

function mapFirebaseAuthError(code: string): string {
  switch (code) {
    case "auth/invalid-credential":
    case "auth/wrong-password":
    case "auth/user-not-found":
      return "Nieprawidlowy email lub haslo."
    case "auth/invalid-email":
      return "Podany adres email jest nieprawidlowy."
    case "auth/invalid-api-key":
      return "Konfiguracja Firebase jest niepoprawna (API key). Skontaktuj sie z administratorem."
    case "auth/user-disabled":
      return "To konto zostalo zablokowane."
    case "auth/too-many-requests":
      return "Zbyt wiele prob. Sprobuj ponownie za chwile."
    case "auth/network-request-failed":
      return "Brak polaczenia z siecia. Sprawdz internet i sprobuj ponownie."
    default:
      return "Wystapil blad logowania. Sprobuj ponownie."
  }
}

export async function loginWithEmailPassword(
  email: string,
  password: string
): Promise<UserCredential> {
  try {
    const auth = getFirebaseAuth()
    return await signInWithEmailAndPassword(auth, email.trim(), password)
  } catch (error: unknown) {
    if (error && typeof error === "object" && "code" in error) {
      throw new Error(mapFirebaseAuthError(String(error.code)))
    }
    throw new Error("Wystapil nieoczekiwany blad logowania.")
  }
}

export async function logout(): Promise<void> {
  const auth = getFirebaseAuth()
  await signOut(auth)
}

export function subscribeToAuthState(callback: (user: User | null) => void) {
  const auth = getFirebaseAuth()
  return onAuthStateChanged(auth, callback)
}
